import { FloatingMessagesUIMessageConfig } from "../../../../components/ui/FloatingMessagesUI";
import { VortexUICurrentAttempt } from "../../../../components/ui/hud/VortexUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import { BaseGeneralConfig, GeneralPartConfig, SuccessType } from "../../general-scenario-stuff";
import { GeneralStepCollection } from "../../GeneralStepCollection";
import GeneralProceduresCricPart9 from "../cric/parts/GeneralProceduresCricPart9";
import GeneralProceduresAuscultatePart1 from "./parts/GeneralProceduresAuscultatePart1";

export default class GeneralProceduresAuscultateMain extends GeneralStepCollection {
	private _parts: BaseScenarioPart<DaarcBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: GeneralProceduresAuscultateMainConfig) {
		super();
		var context = this;
		context._parts.push(new GeneralProceduresAuscultatePart1(this, config.scenario, (isYesClicked: boolean) => {
			context.config.onDone(isYesClicked);
		}, context._partId1, config));
	}

	public start(procedure: VortexUICurrentAttempt) {
		this.config.procedure = procedure;

		if(this.config.scenario.isLite && GeneralProceduresCricPart9.isCricProcedure) {
			this.config.onDone(true);
		} else {
			this.goToStep1();
		}
	}

	goToStep1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface GeneralProceduresAuscultateMainConfig extends BaseGeneralConfig {
	scenario: DaarcBaseScenario;
	squeezeAmbuBag: boolean;
	part1Config?: GeneralProceduresAuscultatePart1Config;
	procedure?: VortexUICurrentAttempt; //to be set internally
	onDone: (isYesClicked: boolean) => void;
}

export interface GeneralProceduresAuscultatePart1Config extends GeneralPartConfig {
	bvmConfig: AuscultateProcedureConfig;
    ettConfig: AuscultateProcedureConfig;
    sgaConfig: AuscultateProcedureConfig;
    cricConfig: AuscultateProcedureConfig;
}

export interface AuscultateProcedureConfig {
	moveToAuscultateScreenVideoChapter: () => string;
	auscultateHoverOverMessages: () => FloatingMessagesUIMessageConfig[];
	checkRiseAndTubeHumidificationText: () => string;
	audioPath: () => string;
	onBeforeDebriefShows?: (onDone: () => void) => void;
	isAnswerCorrect: (isYesClicked: boolean) => boolean;
}